import { useCallback } from 'react';
import { Box, Typography } from '@mui/material';

import { FHConfirmDialog } from '../../../../components/base';
import { FORTA_GRAY5 } from '../../../../utils/colors';

import type { ConfirmDialogProps } from './types';

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  hideCancel = false,
  onConfirm,
  onClose,
  confirmLoading = false,
}: ConfirmDialogProps) {
  const renderContent = useCallback(
    () => (
      <Box sx={{ pt: 1, flexGrow: 1 }}>
        {message ? (
          <Typography sx={{ color: FORTA_GRAY5, fontSize: 14 }}>{message}</Typography>
        ) : null}
      </Box>
    ),
    [message],
  );

  const handleClose = useCallback(() => {
    if (confirmLoading) return;
    onClose();
  }, [confirmLoading, onClose]);

  return (
    <FHConfirmDialog
      open={open}
      title={title}
      submittext={confirmLabel}
      canceltext={cancelLabel}
      hideCancelButton={hideCancel}
      onClose={handleClose}
      onSubmit={onConfirm}
      submitLoading={confirmLoading}
      disableSubmitButton={confirmLoading}
      disableCancelButton={confirmLoading}
      dialogHeight={220}
      contentRenderer={renderContent}
    />
  );
}
